import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2021() {
  const handleDownload1 = () => {
    window.open("assets/2021/Rosie Lalmuanpuii & E Nixon Singh.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open(
      "assets/2021/Lalhriatpuii Ralte & James LT Thanga.pdf",
      "_blank",
    );
  };
  const handleDownload3 = () => {
    window.open("assets/2021/Daniel Lalawmpuia.pdf", "_blank");
  };
  const handleDownload4 = () => {
    window.open("assets/2021/Doumuanlal.pdf", "_blank");
  };
  const handleDownload5 = () => {
    window.open("assets/2021/Lalzuiliana.pdf", "_blank");
  };
  const handleDownload6 = () => {
    window.open("assets/2021/Lalmuansangi.pdf", "_blank");
  };
  const handleDownload7 = () => {
    window.open("assets/2021/Stephan Lalremthara.pdf", "_blank");
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 4, No. 1&2 (2021)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Socio - Economic Status of Women Entrepreneurs - A Case study
                  of Aizawl City in Mizoram.
                </div>
                <div className="text-sm text-green-600">
                  Rosie Lalmuanpuii & E. Nixon Singh
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  A Comparative Study of Employment and Skill Training in
                  Mizoram Vis-À-Vis The National Average
                </div>
                <div className="text-sm text-green-600">
                  Lalhriatpuii Ralte & James LT Thanga
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  A Critical Analysis of Entrepreneurship Development Programme
                  (EDP) Among Urban Poor in Mizoram
                </div>
                <div className="text-sm text-green-600">Daniel Lalawmpuia</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  An Analysis of Global and Mizoram Urban Labour Market Trends
                </div>
                <div className="text-sm text-green-600">Doumuanlal</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Artificial Insemination Technology is a device for Improvement
                  of Farm animals in Mizoram
                </div>
                <div className="text-sm text-green-600">Lalzuiliana</div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Food Processing Industry in Mizoram: An Overview
                </div>
                <div className="text-sm text-green-600">Lalmuansangi</div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  MGNREGS In Aibawk RD Block: A Study From the Perspectives of
                  the Beneficiaries
                </div>
                <div className="text-sm text-green-600">
                  Stephan Lalremthara
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
